import React, { useState, useCallback, useRef } from "react";
import { KYDFilters } from "common/interfaces/KYDCampaign";
import actions from "src/actions";

export const useSegment = () => {
  const [segmentSize, setSegmentSize] = useState<number | null>(null);
  const [segmentSizeLoading, setSegmentSizeLoading] = useState(false);
  const currentRenderController = useRef<AbortController | null>(null);

  const createSegmentQuery = useCallback(async (filters: KYDFilters) => {
    return actions.ADMIN.createSegmentQuery({ filters });
  }, []);

  const fetchSegmentSize = useCallback(
    async (filters: KYDFilters) => {
      try {
        if (currentRenderController.current) {
          currentRenderController.current.abort();
        }

        setSegmentSizeLoading(true);
        const query = await createSegmentQuery(filters);
        currentRenderController.current = query.controller;

        setSegmentSize(query.size);
      } catch (error) {
        console.error("Error calculating segment size:", error);
        throw error;
      } finally {
        setSegmentSizeLoading(false);
      }
    },
    [createSegmentQuery]
  );

  const createSegment = useCallback(
    async (data: {
      name: string;
      filters: KYDFilters;
      type: "static" | "dynamic";
    }) => {
      const query = await createSegmentQuery(data.filters);
      const response = await actions.ADMIN.createSegment({
        name: data.name,
        filters: data.filters,
        query_execution_id: query.query_execution_id,
        type: data.type,
      });

      return response;
    },
    [createSegmentQuery]
  );

  const updateSegment = useCallback(
    async (data: {
      segment_id: string;
      name: string;
      filters: KYDFilters;
      type: "static" | "dynamic";
    }) => {
      const query = await createSegmentQuery(data.filters);
      await actions.ADMIN.updateSegment(data.segment_id, {
        name: data.name,
        type: data.type,
        filters: data.filters,
        query_execution_id: query.query_execution_id,
      });
    },
    []
  );

  return {
    state: {
      segmentSize,
      segmentSizeLoading,
    },
    actions: {
      query: createSegmentQuery,
      createSegment,
      updateSegment,
      fetchSegmentSize,
    },
  };
};
